/**
 * External dependencies
 */
import React from "react";
import { graphql } from "gatsby";

/**
 * Internal dependencies
 */
import { ProductLink, ProductImage } from ".";
import { formatPrice } from "../utilities";

export default function ProductCard({ product }) {
  const { name, brand, images, sku, price } = product;
  return (
    <div className="col-md-3 new-episode" style={{ paddingBottom: "90px" }}>
      <ProductLink link={sku}>
        <ProductImage uri={images.alt_images[0].low_res} />
      </ProductLink>
      <h4 dangerouslySetInnerHTML={{ __html: brand }} />
      <h5 dangerouslySetInnerHTML={{ __html: name }} />
      <p>{formatPrice(price.current)}</p>
    </div>
  );
}

export const query = graphql`
  fragment ProductCardFragment on product {
    name
    categories
    brand
    sku
    images {
      alt_images {
        low_res
        high_res
      }
    }
    price {
      current
      was
    }
  }
`;
